import { useTheme } from '@approvalmax/theme';
import { SimpleLayout, useLayout } from '@approvalmax/ui/src/components';
import { Helmet } from 'react-helmet';
import { useMedia } from 'react-use';

import { HardEnforcementEnd, HardEnforcementStart, HardEnforcementWizard } from './resources/components';
import { useTwoFaHardEnforcement } from './resources/hooks/useTwoFaHardEnforcement';
import { messages } from './resources/messages';

const Page = () => {
    useLayout({ hasHeader: false, hasDrawer: false });

    const { theme } = useTheme();
    const isMobileScreen = useMedia(`(max-width: ${theme.container.breakpoint.xsmall})`);

    const { authenticated, stage, handleWizardStart, handleWizardEnd, handleDone } = useTwoFaHardEnforcement();

    if (!authenticated) {
        return null;
    }

    return (
        <SimpleLayout size={isMobileScreen || stage === 'end' ? 'xsmall' : 'medium'}>
            <Helmet title={messages.title} />

            <SimpleLayout.Content>
                {stage === 'start' && <HardEnforcementStart onStart={handleWizardStart} />}

                {stage === 'wizard' && <HardEnforcementWizard onFinish={handleWizardEnd} />}

                {stage === 'end' && <HardEnforcementEnd onFinish={handleDone} />}
            </SimpleLayout.Content>
        </SimpleLayout>
    );
};

Page.displayName = 'Page';

export default Page;
